import React, { createContext, useContext, useState, useEffect } from 'react';
import { setDir } from './store/customizer/CustomizerSlice';
import { useDispatch } from 'react-redux';
import { get, ref } from 'firebase/database';
import { database } from './book/src/firebase';
import { useAuth } from './views/authentication/AuthContext';
import SentryLogger from './components/logging/SentryLogger';
import { useAuthShop } from './components/pages/shop/AuthShopContext';

const LanguageContext = createContext();

export const useLanguage = () => useContext(LanguageContext);

export const LanguageProvider = ({ children }) => {
  // Use state to hold the current language
  const [language, setLanguage] = useState('en');
  const [supportedLanguages, setSupportedLanguages] = useState(['en', 'ar', 'heb']);
  const [defaultLang, setDefaultLang] = useState('en');

  const { bizId: bizIdFromAuth } = useAuth();
  const { bizId: bizIdFromAuthShop } = useAuthShop();

  const bizId = bizIdFromAuth || bizIdFromAuthShop;
  // const bizId = bizIdFromAuth || '466c97f7-fc24-4ea1-88aa-6e1bf469c757';

  // dispatch(setDir('ltr'));
  const dispatch = useDispatch();

  const logger = new SentryLogger();

  useEffect(() => {
    const fetchSupportedLangs = async () => {
      try {
        const dbRef = ref(database, `/biz/configs/${bizId}/supportedLanguages`);
        const snapshot = await get(dbRef);

        if (snapshot.exists()) {
          const supportedLangs = snapshot.val();
          setSupportedLanguages(Object.keys(supportedLangs));
        }
      } catch (error) {
        logger.error(error);
        console.error(error);
      }
    };

    if (bizId) {
      fetchSupportedLangs();
    }
  }, [bizId]);

  useEffect(() => {
    const fetchSupportedLangs = async () => {
      try {
        const dbRef = ref(database, `/biz/configs/${bizId}/defaultLang`);
        const snapshot = await get(dbRef);

        if (snapshot.exists()) {
          const defaultLang = snapshot.val();
          setDefaultLang(defaultLang);
        }
      } catch (error) {
        logger.error(error);
      }
    };

    if (bizId) {
      fetchSupportedLangs();
    }
  }, [bizId]);

  useEffect(() => {
    const fetchLanguage = async () => {
      let savedLanguage = localStorage.getItem('languageV2');

      // try {
      //   savedLanguage =
      //   const gg = 'fg';
      // } catch (e) {
      //   console.log(e);
      // }

      if (bizId) {
        if (savedLanguage) {
          // Check if saved language is supported, otherwise use defaultLang
          if (supportedLanguages.includes(savedLanguage)) {
            switchLanguage(savedLanguage);
          } else if (defaultLang) {
            switchLanguage(defaultLang);
          }
          // setLanguage(savedLanguage);
          // dispatch(setDir(savedLanguage === 'en' ? 'ltr' : 'rtl'));
        } else {
          try {
            const dbRef = ref(database, `/biz/configs/${bizId}/defaultLang`);
            const snapshot = await get(dbRef);

            if (snapshot.exists()) {
              const defaultLanguage = snapshot.val();

              // Only switch if the language is supported
              if (supportedLanguages.includes(defaultLanguage)) {
                switchLanguage(defaultLanguage);
              } else if (supportedLanguages.length > 0) {
                // Fallback to first supported language
                switchLanguage(supportedLanguages[0]);
              }

              // setLanguage(defaultLanguage);
              // dispatch(setDir(defaultLanguage === 'en' ? 'ltr' : 'rtl'));
            }
          } catch (error) {
            console.error(error);
            logger.error(error);
          }
        }
      } else {
        if (savedLanguage) {
          // Check if saved language is supported, otherwise use defaultLang
          if (supportedLanguages.includes(savedLanguage)) {
            switchLanguage(savedLanguage);
          } else if (defaultLang) {
            switchLanguage(defaultLang);
          }
          // setLanguage(savedLanguage);
          // dispatch(setDir(savedLanguage === 'en' ? 'ltr' : 'rtl'));
        } else {
          // const browserLanguage = navigator.language.split('-')[0];
          const browserLanguage = 'en';

          // Only switch if the language is supported
          if (supportedLanguages.includes(browserLanguage)) {
            switchLanguage(browserLanguage);
          } else if (supportedLanguages.length > 0) {
            // Fallback to first supported language
            switchLanguage(supportedLanguages[0]);
          }
          // setLanguage(browserLanguage);
          // localStorage.setItem('language', browserLanguage);
          // console.log(browserLanguage);
          // dispatch(setDir(browserLanguage === 'en' ? 'ltr' : 'rtl'));
        }
      }
    };
    fetchLanguage();
  }, [bizId]);

  // Check if current language is supported when supportedLanguages or defaultLang changes
  useEffect(() => {
    if (supportedLanguages.length > 0 && defaultLang) {
      // If current language is not in supported languages, switch to default
      if (!supportedLanguages.includes(language)) {
        switchLanguage(defaultLang);
      }
    }
  }, [supportedLanguages, defaultLang]);

  const isLTR = () => {
    return language === 'en' || language === 'ru';
  };

  const setupDefaultLanguage = async (bizId) => {
    try {
      const dbRef = ref(database, `/biz/configs/${bizId}/defaultLang`);
      const snapshot = await get(dbRef);

      if (snapshot.exists()) {
        const defaultLanguage = snapshot.val();

        switchLanguage(defaultLanguage);

        // setLanguage(defaultLanguage);
        // dispatch(setDir(defaultLanguage === 'en' ? 'ltr' : 'rtl'));
      }
    } catch (error) {
      console.error(error);
      logger.error(error);
    }
  };

  const switchLanguage = (lang) => {
    setLanguage(lang);
    localStorage.setItem('languageV2', lang);
    dispatch(setDir(lang === 'en' || lang === 'ru' ? 'ltr' : 'rtl'));
  };

  return (
    <LanguageContext.Provider
      value={{
        language,
        switchLanguage,
        supportedLanguages,
        defaultLang,
        setupDefaultLanguage,
        isLTR,
      }}
    >
      {children}
    </LanguageContext.Provider>
  );
};
